// extracted by mini-css-extract-plugin
export default {"input":"Fg_iI7"};